import { memo, useCallback } from "react";
import { BottomSheetView, type BottomSheetModal } from "@gorhom/bottom-sheet";
import { StyleSheet, useUnistyles } from "react-native-unistyles";
import { Text } from "@src/components";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { AppBottomSheet } from "@src/features/common/components/AppBottomSheet";
import { RemoveAccessContent } from "./RemoveAccessContent";

interface RemoveAccessBottomSheetProps {
  bottomSheetRef: React.RefObject<BottomSheetModal | null>;
  title: string;
  message: string;
  onConfirm: () => void;
}

export const RemoveAccessBottomSheet = memo(
  ({ bottomSheetRef, title, message, onConfirm }: RemoveAccessBottomSheetProps) => {
    const { theme } = useUnistyles();
    const { bottom } = useSafeAreaInsets();

    const handleConfirm = useCallback(() => {
      onConfirm();
      setTimeout(() => {
        bottomSheetRef.current?.dismiss();
      }, 100);
    }, [onConfirm, bottomSheetRef]);

    return (
      <AppBottomSheet
        bottomSheetRef={bottomSheetRef}
        enableDynamicSizing
        backgroundStyle={{ backgroundColor: theme.colors.surfaceCard }}
      >
        <BottomSheetView
          style={[styles.container, { paddingBottom: bottom + theme.spacing["5xl"], paddingTop: theme.spacing.md }]}
        >
          <Text textStyle="md/medium" style={styles.title}>
            {title}
          </Text>
          <RemoveAccessContent message={message} onConfirm={handleConfirm} />
        </BottomSheetView>
      </AppBottomSheet>
    );
  },
);

const styles = StyleSheet.create((theme) => ({
  container: {
    paddingHorizontal: theme.spacing["5xl"],
  },
  title: {
    marginBottom: theme.spacing["4xl"],
  },
}));
